import React from "react";
import { Breadcrumbs, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

export default function PageHeading({ title, subtitle, pageTitle, disclaimer }) {
  return (
    <Container>
      <div className="about_banner_content">
        <Typography variant="h1" className="heading_one">
          {pageTitle}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" separator="›" className="breadcrumbs">
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            to="/"
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            variant="p"
          >
            {title}
          </Link>
          {subtitle && (
            <Typography color="textPrimary" variant="p">
              {subtitle}
            </Typography>
          )}
        </Breadcrumbs>
        {disclaimer && (
          <div style={{ marginTop: "20px", paddingTop: "16px", borderTop: "1px solid rgba(255,255,255,0.12)" }}>
            <Typography
              style={{
                fontWeight: 700,
                color: "#F9A825",
                fontSize: "0.68rem",
                letterSpacing: "0.13em",
                textTransform: "uppercase",
                marginBottom: "6px",
              }}
            >
              ⚠ Important Disclaimer
            </Typography>
            <Typography
              style={{
                color: "rgba(255,255,255,0.52)",
                fontSize: "0.68rem",
                lineHeight: 1.85,
              }}
            >
              {disclaimer}
            </Typography>
          </div>
        )}
      </div>
    </Container>
  );
}
